import { render, staticRenderFns } from "./CreateInsuranceProducts.vue?vue&type=template&id=15cf2216"
import script from "./CreateInsuranceProducts.vue?vue&type=script&lang=js"
export * from "./CreateInsuranceProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports